import React,{useState,useEffect} from "react"
import { getImage } from 'gatsby-plugin-image'
import {imgSwitch} from './hero.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle as faCH } from '@fortawesome/free-regular-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import {fontColorWhite} from './shared.module.scss'

const Hero = ({heroimg,heroslides})=>{
    //console.log(heroimg);
    const [backgroundIndex, setBackgroundIndex] = useState(0);
    const [imgs, setImgs] = useState([]);
    const [firstClick, setFirstClick] = useState(false);

    //setting up slides for mobile swipe 
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    // Minimum swipe distance (you can adjust this value)
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        setTouchEnd(null); // Reset touchEnd to null
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            // Move to next slide
            handleSlides((backgroundIndex + 1) % imgs.length);
        } else if (isRightSwipe) {
            // Move to previous slide
            handleSlides((backgroundIndex - 1 + imgs.length) % imgs.length);
        }
    };
    //end added for mobile swipe




    const handleSlides = (n)=>{
        setBackgroundIndex(n);
    }

    const slideAuto = ()=>{
        let n = backgroundIndex + 1;
        if(n >= imgs.length){
            n = 0;//loop
        }
        setBackgroundIndex(n);
    }

    useEffect(() => {
        let bgimage = heroimg ? getImage(heroimg.gatsbyImageData) : false;
        let bgimg = bgimage ? bgimage.images.fallback.src : '';

        let temp_imgs = [];
          let loadedCount = 0;

        const handleImageLoad = () => {
            loadedCount++;
            if (loadedCount === heroslides.length) {
              setImgs(temp_imgs);
            }
          };

        if(heroslides){
            //heroslides.map((img)=>{
            //    let image = getImage(img.gatsbyImageData);
            //    temp_imgs.push(image.images.fallback.src);
            //});
            heroslides.forEach((img) => {
              let image = getImage(img.gatsbyImageData);
              const imgSrc = image.images.fallback.src;
              const imgElement = new Image();
              imgElement.src = imgSrc;
              imgElement.onload = handleImageLoad;
             temp_imgs.push(imgSrc);
            });

        }

        if(temp_imgs.length == 0){
            //backup for communities without slideshow
            temp_imgs.push(bgimg);
        }

        setImgs(temp_imgs);

        const interval = setInterval(slideAuto, 5000);
        
        if(!firstClick){
            setTimeout(() => {
            handleSlides(backgroundIndex+1);
            setFirstClick(true);
          }, 5000); 
        }
        

        return () => clearInterval(interval);

    }, [backgroundIndex])

    return(
        <section 
        className={imgSwitch+" hero is-fullheight"} 
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        style={imgs[backgroundIndex] ? {backgroundImage:'url('+imgs[backgroundIndex]+')',
            backgroundSize:'cover',
            backgroundPosition:'center',
            backgroundRepeat:'no-repeat'
            } : {}}>
            <div className="hero-head" >
            </div>
            <div className="hero-body" >
            </div>
            <div className="hero-foot">
                <div className="container">
                    <div className="columns">
                        <div className="column has-text-centered">
                        {imgs.map((f,i)=>(
                            <FontAwesomeIcon icon={ backgroundIndex == i ? faCircle : faCH  } 
                            onClick={()=>{handleSlides(i)}} 
                            size="lg" 
                            key={i}
                            className={fontColorWhite}
                                style={{paddingRight:'5px',cursor:'pointer',marginBottom:'1rem'}} />
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Hero
